import React from 'react';
import {
  Box,
  Flex,
  Icon,
  Text,
  keyframes,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import { getClassDisplayText } from 'utils/instructorClassWorkflows';

const popIn = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, -44%) scale(0.76);
  }
  55% {
    opacity: 1;
    transform: translate(-50%, -52%) scale(1.06);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

const ringPulse = keyframes`
  0% {
    opacity: 0.55;
    transform: scale(0.72);
  }
  100% {
    opacity: 0;
    transform: scale(1.55);
  }
`;

export default function ClaimSuccessAnimation({ isVisible, classData }) {
  const cardBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const mutedText = useColorModeValue('gray.600', 'gray.300');
  const className = getClassDisplayText(
    classData?.ClassName || classData?.ClassType,
    'Class'
  );

  if (!isVisible) return null;

  return (
    <Flex
      data-testid="claim-success-animation"
      position="fixed"
      inset="0"
      zIndex="popover"
      pointerEvents="none"
      align="center"
      justify="center"
      bg="blackAlpha.200"
    >
      <Box
        position="absolute"
        left="50%"
        top="50%"
        animation={`${popIn} 0.48s cubic-bezier(0.34, 1.56, 0.64, 1) both`}
      >
        <Flex
          position="relative"
          direction="column"
          align="center"
          gap="10px"
          bg={cardBg}
          borderRadius="22px"
          boxShadow="0 22px 60px rgba(43, 132, 196, 0.28)"
          px="28px"
          py="24px"
          minW={{ base: '260px', md: '340px' }}
          textAlign="center"
        >
          <Box
            position="absolute"
            top="18px"
            w="58px"
            h="58px"
            borderRadius="full"
            bg="green.300"
            animation={`${ringPulse} 0.9s ease-out infinite`}
          />
          <Icon as={MdCheckCircle} color="green.500" w="58px" h="58px" zIndex="1" />
          <Text color={textColor} fontSize="xl" fontWeight="900">
            Class claimed!
          </Text>
          <Text color={mutedText} fontSize="sm" fontWeight="700">
            {className} is now on your calendar.
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
}
